import { createSelector } from "@reduxjs/toolkit";
import { IStoreState } from "../../../../reducers/types";
import dayjs from "dayjs";
import { filterOutSpendAndGetOffers } from "halifax";

export const getAllTravelWalletOffers = (state: IStoreState) =>
  state.carTravelWallet.offers;

export const getTravelWalletOffers = createSelector(
  getAllTravelWalletOffers,
  (offers) => filterOutSpendAndGetOffers(offers)
);

export const getActiveTravelWalletOffers = createSelector(
  getTravelWalletOffers,
  (offers) => {
    return offers.filter((offer) => {
      return dayjs().isAfter(dayjs(offer?.saleEventStartOn));
    });
  }
);

export const getTravelWalletCredit = (state: IStoreState) =>
  state.carTravelWallet.credit;

export const getCreditBreakdown = (state: IStoreState) =>
  state.carTravelWallet.creditBreakdown;

export const getTravelCreditsHistoryTransaction = (state: IStoreState) =>
  state.carTravelWallet.creditsHistoryTransactions;

export const getPartialHistoryValidFromTime = (state: IStoreState) =>
  state.carTravelWallet.partialHistoryValidFromTime;
